<nz-select [nzShowSearch]="showSearch" [nzAllowClear]="allowClear" [disabled]="disabled" [nzPlaceHolder]="placeholder"
    [(ngModel)]="value" [nzDisabled]="readOnlyMode" (ngModelChange)="codeChange($event)" [nzMode]="mode">
    <nz-option *ngFor="let option of typeOptions" [nzLabel]="option.value | localize" [nzValue]="option.key">
    </nz-option>
</nz-select>